// 코로나 현황 mixin
import { $WC } from '@/conf/common.const.js';
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            covidState: 'getCovidState',
            latestVaccination: 'getLatestVaccination',
        }),
        latestCovidState () {
            let latestCovidState = {}
            if (typeof this.covidState[0] !== $WC.UNDEF) {
                latestCovidState = this.covidState[0]
            }

            return latestCovidState
        },
        preCovidState () {
            let preCovidState = {}
            if (typeof this.covidState[1] !== $WC.UNDEF) {
                preCovidState = this.covidState[1]
            }
            return preCovidState
        },
        latestCareCnt () {
            return Number(this.latestCovidState.val4) - Number(this.latestCovidState.val5) - Number(this.latestCovidState.val8);
        },
        preCareCnt () {
            if (typeof this.preCovidState.basdtVal !== $WC.UNDEF) {
                return Number(this.preCovidState.val4) - Number(this.preCovidState.val5) - Number(this.preCovidState.val8);
            }
            return 0;
        },
        latestIsolatedCnt () {
            return Number(this.latestCovidState.val6) + Number(this.latestCovidState.val7)
        },
        diffConfirmedCntInfo () {
            let diffConfirmedCntInfo = {
                diff: 0,
                calss: '',
                flag: '-'
            }

            /*
            if (typeof this.preCovidState.basdtVal !== $WC.UNDEF) {
                let diffConfirmedCnt = Number(this.latestCovidState.val4) - Number(this.preCovidState.val4);

                diffConfirmedCntInfo.diff = Math.abs(diffConfirmedCnt)
                if (diffConfirmedCnt > 0) {
                    diffConfirmedCntInfo.class = 'up'
                    diffConfirmedCntInfo.flag = '▲'
                } else if (diffConfirmedCnt < 0) {
                    diffConfirmedCntInfo.class = 'down'
                    diffConfirmedCntInfo.flag = '▼'
                } else {
                    diffConfirmedCntInfo.class = ''
                    diffConfirmedCntInfo.flag = '-'
                }

                if(isNaN(diffConfirmedCntInfo.diff)) {
                    diffConfirmedCntInfo.diff = '';
                    diffConfirmedCntInfo.class = ''
                    diffConfirmedCntInfo.flag = '-'
                }
            } else {
                diffConfirmedCntInfo.class = ''
                diffConfirmedCntInfo.flag = '-'
            }
            */

            let diffConfirmedCnt = 0;
            if (typeof this.preCovidState.basdtVal !== $WC.UNDEF) {
                diffConfirmedCnt = Number(this.latestCovidState.val4) - Number(this.preCovidState.val4);
            } else {
                diffConfirmedCnt = Number(this.latestCovidState.val9);
            }

            diffConfirmedCntInfo.diff = Math.abs(diffConfirmedCnt)

            if (diffConfirmedCnt > 0) {
                diffConfirmedCntInfo.class = 'up'
                diffConfirmedCntInfo.flag = '▲'
            } else if (diffConfirmedCnt < 0) {
                diffConfirmedCntInfo.class = 'down'
                diffConfirmedCntInfo.flag = '▼'
            } else {
                diffConfirmedCntInfo.class = ''
                diffConfirmedCntInfo.flag = '-'
            }

            if(isNaN(diffConfirmedCntInfo.diff)) {
                diffConfirmedCntInfo.diff = '';
                diffConfirmedCntInfo.class = ''
                diffConfirmedCntInfo.flag = '-'
            }

            return diffConfirmedCntInfo;
        },

        firstDiffVaccinationCntInfo() {
            let diffInfo = {
                diff: 0,
                calss: '',
                flag: '-'
            };

            if(typeof this.latestVaccination.val9 !== 'undefined' && this.latestVaccination.val9 !== '') {
                let diffCnt = Number(this.latestVaccination.val9);
                diffInfo.diff = diffCnt;
                if (diffCnt > 0) {
                    diffInfo.class = 'up'
                    diffInfo.flag = '▲'
                } else if (diffCnt < 0) {
                    diffInfo.class = 'down'
                    diffInfo.flag = '▼'
                } else {
                    diffInfo.class = ''
                    diffInfo.flag = '-'
                }
            }

            return diffInfo;
        },
        secondDiffVaccinationCntInfo() {
            let diffInfo = {
                diff: 0,
                calss: '',
                flag: '-'
            };

            if(typeof this.latestVaccination.val10 !== 'undefined' && this.latestVaccination.val10 !== '') {
                let diffCnt = Number(this.latestVaccination.val10);
                diffInfo.diff = diffCnt;
                if (diffCnt > 0) {
                    diffInfo.class = 'up'
                    diffInfo.flag = '▲'
                } else if (diffCnt < 0) {
                    diffInfo.class = 'down'
                    diffInfo.flag = '▼'
                } else {
                    diffInfo.class = ''
                    diffInfo.flag = '-'
                }
            }

            return diffInfo;
        },
    }
}
